import { createApp } from 'vue'
import App from './App.vue'
import Element from "element-plus";
import "element-plus/theme-chalk/index.css";
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '../src/rem'
import '../src/font/iconfont.css'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(router).use(Element).mount('#app')
